// extracted by mini-css-extract-plugin
module.exports = {"aboutContent":"dp-BG1Pklnp","topImage":"dp-KeWk3TXa","content":"dp-HiB6nJ2v"};